/* eslint-disable no-undef */
const languageMenu = document.getElementById("language-menu");
const currentUrl = window.location.href;
const urlObj = new URL(currentUrl);
const currentPathname = urlObj.pathname;
const currentSearch = urlObj.search;
const languageToggleButton = document.getElementById("language-toggle");
const languageIconClose = languageToggleButton.querySelectorAll(".lang-icon-close");
const languageIconOpen = languageToggleButton.querySelectorAll(".lang-icon-open");
const labelBox = languageToggleButton.querySelector(".language-svg-box");

function toggleLanguageActive() {
  languageIconClose.forEach((icon) => icon.classList.toggle("active"));
  languageIconOpen.forEach((icon) => icon.classList.toggle("active"));
  labelBox.classList.toggle("active");
}

function removeLanguageActive() {
  languageIconClose.forEach((icon) => icon.classList.remove("active"));
  languageIconOpen.forEach((icon) => icon.classList.remove("active"));
  labelBox.classList.remove("active");
}

languageToggleButton.addEventListener("click", (e) => {
  e.stopPropagation();
  toggleLanguageActive();
});

document.addEventListener("click", (e) => {
  const isClickInside = languageToggleButton.contains(e.target) || languageMenu.contains(e.target);
  if (!isClickInside) {
    removeLanguageActive();
  }
});

const observer = new MutationObserver(() => {
  const isHidden =
    languageMenu.offsetParent === null ||
    window.getComputedStyle(languageMenu).display === "none";

  if (isHidden) {
    removeLanguageActive();
  }
});

observer.observe(languageMenu, { attributes: true, attributeFilter: ["style", "class"] });

function generateLanguageLink(lang) {
  if (currentPathname === "/templates/search") {
    if (urlObj.hostname === "localhost" || urlObj.hostname.startsWith("127.0.0.")) {
      return `${urlObj.origin}${currentPathname}?lang=${lang}`;
    } else {
      const domain = urlObj.hostname.replace(/^(en\.|ua\.|ru\.|es\.|br\.|fr\.|de\.|tr\.)/, "");
      let newHost;
      if (lang === "en") {
        newHost = domain;
      } else {
        newHost = `${lang}.${domain}`;
      }
      return `${urlObj.protocol}//${newHost}${currentPathname}?lang=${lang}`;
    }
  } else if (urlObj.hostname === "localhost" || urlObj.hostname.startsWith("127.0.0.")) {
    return `${urlObj.origin}${currentPathname}?lang=${lang}`;
  } else {
    const domain = urlObj.hostname.replace(/^(en\.|ua\.|ru\.|es\.|br\.|fr\.|de\.|tr\.)/, "");
    let newHost;
    if (lang === "en") {
      newHost = domain;
    } else {
      newHost = `${lang}.${domain}`;
    }
    return `${urlObj.protocol}//${newHost}${currentPathname}${currentSearch}`;
  }
}

const languageItems = Array.from(languageMenu.querySelectorAll("li"));
languageMenu.innerHTML = "";

const midPoint = Math.ceil(languageItems.length / 2);
const firstColumnItems = languageItems.slice(0, midPoint);
const secondColumnItems = languageItems.slice(midPoint);

const firstColumnUl = document.createElement("ul");
firstColumnUl.classList.add("language-column");
firstColumnItems.forEach(item => firstColumnUl.appendChild(item));

const secondColumnUl = document.createElement("ul");
secondColumnUl.classList.add("language-column");
secondColumnItems.forEach(item => secondColumnUl.appendChild(item));

const menuLine = document.createElement("div");
menuLine.classList.add("lang-menu-line", "dropdown-li");

languageMenu.style.display = "flex";
languageMenu.style.justifyContent = "center";

languageMenu.appendChild(firstColumnUl);
languageMenu.appendChild(menuLine);
languageMenu.appendChild(secondColumnUl);

languageMenu.querySelectorAll("a").forEach((link) => {
  const lang = link.dataset.lang;
  link.href = generateLanguageLink(lang);

  link.addEventListener("click", function (event) {
    event.preventDefault();
    window.location.href = this.href;
  });
});
